// The premium 300-thread-count sateen is identified by a suffix on the product code, not by its own
// material row: these products carry the plain sateen materialAttributeId in the DB, so the code is
// the only thing telling them apart from standard sateen.
//
// The suffix is spelled "300tc" in the catalogue and was "300ts" before it was renamed. Accept both:
// a code that stops matching does not fail loudly, it silently downgrades the product to the generic
// "Памучен сатен" label. Also tolerate a space ("300 TC") and stray trailing whitespace, both of
// which occur in the catalogue.
const SATEEN_300_SUFFIX = /300\s*t[sc]$/i;

export const isSateen300 = (code) => SATEEN_300_SUFFIX.test((code || '').trim());
